@if (icon()) {
  <div class="tt-no-results_icon">
    <mat-icon data-testid="no-results_icon" [icon]="icon()" [iconSize]="effectiveIconSize()" />
  </div>
}

@if (message() || title()) {
  <div class="tt-no-results_text">
    @if (title()) {
      <div class="tt-no-results_text-title">
        {{ title() | transloco }}
      </div>
    }

    @if (message()) {
      <div class="tt-no-results_text-message">
        {{ message() | transloco }}
      </div>
    }
  </div>
}

<ng-content />

@if (actionLabel()) {
  <button ttButton [variant]="'secondary'" (click)="actionClicked.emit($event)">
    @if (actionIcon()) {
      <mat-icon [icon]="actionIcon()" />
    }
    {{ actionLabel() | transloco }}
  </button>
}
